import {QueryResult, useQuery} from "@apollo/client";
import {GET_ENTITY_PARAMETER_KEY_MAP} from "../api/queries";
import {EntityString} from "../../inputData/types";

const useEntityParameterKeyMap = (): Record<EntityString, string[]> => {
    const {data} =  useQuery(GET_ENTITY_PARAMETER_KEY_MAP);
    return data ? data.fetchEntityParameterKeyMap : null
};

export default useEntityParameterKeyMap;